//vanilla-back-to-top
if (typeof window.addBackToTop === 'function') {
  window.addBackToTop({
    diameter: 64,
    backgroundColor: '#fab71c',
    textColor: '#151117'
  });
}
